import React from "react"
import { useTranslation } from "react-i18next"

import { motion, AnimatePresence } from "services/framerMotion"
import { useDrawer } from "hooks/useDrawer"

import { CrossIcon } from "components/Elements/Icons"

import "./Drawer.scoped.scss"

export const DrawerOverlayVariants = {
    open: {
        opacity: "0.6",
        transition: {
            when: "beforeChildren",
            delay: "0.2"
        }
    },
    closed: {
        opacity: "0",
        transition: {
            when: "afterChildren"
        },
    }
}

export const DrawerVariants = {
    open: {
        x: "0%",
        transition: {
            delay: "0.2"
        }
    },
    closed: {
        x: "110%"
    }
}

const Drawer = ({ children, onClose, drawerClassName, ...props }) => {
    const { t } = useTranslation()
    return (
        <AnimatePresence>
            {children && (
                <motion.div
                    key="drawer-wrapper"
                    className="c-drawer-wrapper">
                    <motion.div className={"c-drawer-overlay"}
                        key="drawer-overlay"
                        onClick={onClose}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={DrawerOverlayVariants}>
                    </motion.div>

                    <motion.div className={"c-drawer " + (drawerClassName ? drawerClassName : "")}
                        {...props}
                        key="drawer"
                        onClick={e => e.stopPropagation()}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={DrawerVariants}
                    >
                        <div className="flex justify-end p-5">
                            <button onClick={onClose} aria-label={t("menu.close")} className="c-drawer__close u-pd-xs">
                                <CrossIcon size={25} />
                                <span className="mt-1 text-xxs">
                                    {t("global.close")}
                                </span>
                            </button>
                        </div>

                        {children}
                    </motion.div>
                </motion.div>
            )}
         </AnimatePresence>
    )
}

const DrawerRoot = () => {
    const { component, hideDrawer } = useDrawer()
    return (
        <Drawer onClose={hideDrawer}>
            { component }
        </Drawer>
    )
}


export { Drawer as default, DrawerRoot }
